
























import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { DealDocumentCopyHistoryModel, DealDocumentCopyRequestStatus } from '@/types';
import { ProcessLeaver } from '@/mixins';
import { EnumUtils } from '@/utils';
import { DealDocumentCopyService } from '@/services';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'DealCopyHistory',
  mixins: [ProcessLeaver],
  data() {
    return {
      isLoading: true,
      status: -1,
      dealDocumentCopyHistory: [] as DealDocumentCopyHistoryModel[],
      searchQuery: '',
      fields: [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'userId',
          label: 'User Id',
          sortable: true
        },
        {
          key: 'userName',
          label: 'User Name',
          sortable: true
        },
        {
          key: 'formerStockNumber',
          label: 'Former Stock Number',
          sortable: true
        },
        {
          key: 'currentStockNumber',
          label: 'Current Stock Number',
          sortable: true
        },
        {
          key: 'exceptionMessage',
          label: 'Exception Message',
          sortable: true
        },
        {
          key: 'lastUpdated',
          label: 'Last Updated',
          formatter: 'date',
          sortable: true
        },
        {
          key: 'statusDescription',
          label: 'Status',
          sortable: true
        },
        {
          key: 'requestDate',
          label: 'Request Date',
          formatter: 'date',
          sortable: true
        }
      ]
    };
  },
  methods: {
    async getDealDocumentsAsync(this: any) {
      await DealDocumentCopyService.getDealCopyHistoryAsync()
        .then(async (response: DealDocumentCopyHistoryModel[]) => {
          this.dealDocumentCopyHistory = response;
          this.isLoading = false;
        })
        .catch((error) => {
          SnotifyConfiguration.showError('An error occured retrieving deal document copy history.');
          this.isLoading = false;
        });
    }
  },
  computed: {
    statusDropdownOptions(this: any) {
      const statuses = EnumUtils.getEnumValues(DealDocumentCopyRequestStatus);
      statuses.push({ key: -1, value: 'All', description: 'All' });
      return statuses;
    },
    filteredDealCopyHistory(this: any): DealDocumentCopyHistoryModel[] {
      let filteredDealDocumentCopyHistory = this.dealDocumentCopyHistory;
      if (this.status > -1) {
        filteredDealDocumentCopyHistory = filteredDealDocumentCopyHistory.filter((x: DealDocumentCopyHistoryModel) => x.status === this.status);
      }
      return filteredDealDocumentCopyHistory;
    }
  },
  async mounted() {
    await this.getDealDocumentsAsync();
  },
  components: {
    MStoreTable,
    MStoreFormSelect,
    LoadingSpinner
  }
});
